import { combineReducers } from 'redux';
import referenceData from './referenceData';
import table from './table';

export const priceTable = combineReducers({
    referenceData,
    table,
});
